export default __webpack_public_path__ + "35be744f22887568401b3dd60830d0d2.png";